import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes/routes";
import { Toaster } from "./components/ui/toaster";

const App = () => {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
};

export default App;
